export function extractApiErrorMessage(
  errorData: unknown,
  fallback = "Request failed"
): string {
  if (!errorData || typeof errorData !== "object") {
    return fallback;
  }

  const payload = errorData as Record<string, unknown>;

  const detail = typeof payload.detail === "string" ? payload.detail.trim() : "";
  const title = typeof payload.title === "string" ? payload.title.trim() : "";
  if (
    detail.includes("Please try again later") &&
    title.length > 0 &&
    title !== "An unexpected error occurred"
  ) {
    return title;
  }

  const candidates = [payload.message, payload.Message, payload.detail, payload.title, payload.error];

  for (let index = 0; index < candidates.length; index += 1) {
    const candidate = candidates[index];
    if (typeof candidate === "string" && candidate.trim().length > 0) {
      return candidate;
    }
  }

  return fallback;
}
